<script>
  // Logic
  import { afterUpdate, onMount } from "svelte";
  import { vaksineData } from "../utils/apiStore";
  import { getPercentage, numberWithSpaces } from "../utils/utils";
  import Arrow from "./icon/Arrow.svelte";
  import Progress from "./Progress.svelte";

  // Bindings
  $: kommuneliste = [];
  let viewMore = false;
  let orders = {
    kommunenavn: 0,
    total: 1,
    dose1prosent: 0,
    dose2prosent: 0,
    dose3prosent:0
  }

  $: colorScale = [
    { numb: 0, bg: "#B4F7C3", color: "#222222" },
    { numb: 0, bg: "#89E7A7", color: "#222222" },
    { numb: 0, bg: "#66CF92", color: "#222222" },
    { numb: 0, bg: "#39AF77", color: "#fff" },
    { numb: 0, bg: "#29966D", color: "#fff" },
    { numb: 0, bg: "#1C7D63", color: "#fff" },
  ];

  onMount(() => {
    vaksineData.subscribe((res) => {
      if (res != undefined) {
        // kommuneliste = res.sort((a, b) => getPercentage(b.total,b.befolkning)- getPercentage(a.total,a.befolkning));
        kommuneliste = res.sort((a, b) => b.total - a.total);
        
        let maxPercentage = 0;
        let minPercentage = 100;
        kommuneliste.map((r) => {
          let coverage = getPercentage(r.total, r.befolkning);
          
          if (coverage > maxPercentage) {
            maxPercentage = coverage;
          }
          if (coverage < minPercentage) {
            minPercentage = coverage;
          }
        });

        colorScale[0].numb = minPercentage;
        colorScale[1].numb = (maxPercentage / 5) * 1;
        colorScale[3].numb = (maxPercentage / 5) * 2;
        colorScale[3].numb = (maxPercentage / 5) * 3;
        colorScale[4].numb = (maxPercentage / 5) * 4;
        colorScale[5].numb = parseFloat(maxPercentage);
        
      }
    });
  });

  const handleViewMore = () => {
    viewMore = !viewMore;
  };


  const sortOn = (key) => {
    if (!viewMore) viewMore = true;
    const dir = orders[key];
    resetSort()
    orders[key] = dir >= 0 ? -1 : 1;
      kommuneliste = kommuneliste.sort((a, b) => {
        if(a[key] < b[key]) {
          return -orders[key]
        } 
        if(a[key] > b[key]) {
          return orders[key]
        }  
        return 0;
    });
  }

  const resetSort = () => {
    Object.keys(orders).forEach(key => {
      orders[key] = 0;
    })
  }
</script>

<div class="kommunetable mt-3">
  <div class="table remove-last-border">
    <div class="vaksine-row header">
      <div class="cell">
        <button class="btn btn-sortable table-btn" class:sortable={viewMore} on:click={() => sortOn('kommunenavn')} >Kommune {#if viewMore}<Arrow direction={orders.kommunenavn} />{/if}</button>
        </div>
       <div class="cell no-mobile">
        <button class="btn btn-sortable table-btn" class:sortable={viewMore} on:click={() => sortOn('total')} >Doser satt {#if viewMore}<Arrow direction={orders.total} />{/if}</button>
       </div>
       <div class="cell">
        <button class="btn btn-sortable table-btn" class:sortable={viewMore} on:click={() => sortOn('dose1prosent')} >Minst<br> én dose{#if viewMore}<Arrow direction={orders.dose1prosent} />{/if}</button>
      </div>
      <div class="cell">
        <button class="btn btn-sortable table-btn table-btn-left" class:sortable={viewMore} on:click={() => sortOn('dose2prosent')} >Andre<br> dose{#if viewMore}<Arrow direction={orders.dose2prosent} />{/if}</button>
      </div>
      <div class="cell">
        <button class="btn btn-sortable table-btn table-btn-left" class:sortable={viewMore} on:click={() => sortOn('dose3prosent')} >Tredje<br> dose{#if viewMore}<Arrow direction={orders.dose3prosent} />{/if}</button>
      </div>
      </div>
      {#each kommuneliste as row, i}
        {#if viewMore ? true : i <= 5}
          <div class="vaksine-row">
            <div class="cell">
              {row.kommunenavn}
                <Progress
                onlyMobile={true}
                max={row.befolkning}
                values={[row.dose1,row.dose2,row.dose3]}
              />
            </div>
            <div class="cell center no-mobile">{numberWithSpaces(row.total)}</div>
            <div class="cell">
              {row.dose1prosent}%
              <Progress
                max={row.befolkning}
                onlyDesktop={true}
                values={[row.dose1]}
              />
            </div>
            <div class="cell">
              {row.dose2prosent}%
              <Progress
                max={row.befolkning}
                onlyDesktop={true}
                colors={['green']}
                values={[row.dose2]}
              />
            </div>
            
            <div class="cell">
              {row.dose3prosent}%
              <Progress
                max={row.befolkning}
                onlyDesktop={true}
                colors={['dark']}
                values={[row.dose3]}
              />
            </div>
          </div>
        {/if}
      {/each}
  </div>
  <button class="btn btn-center mt-2" on:click={() => handleViewMore()}
    >{viewMore ? "Trekk sammen listen" : "Vis alle"}</button
  >
</div>

<style lang="scss">
  .kommunetable {
    display: flex;
    flex-direction: column;

    .vaksine-row {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: 1fr;
      grid-column-gap: 4px;
      grid-row-gap: 6px;
      min-height: 40px;
      padding: .7rem 0;
      &.header {
        border-bottom: $border-width solid $border-color;
        .cell {
          align-self: flex-end;
        }
      }
      &:not(:first-of-type) {
        border-top: solid 1px #C7C7C7;
      }
      
      .cell {
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include desktop {
        }
        &:nth-of-type(1) {
          grid-area: 1 / 1 / 2 / 3;
          display: flex;
          flex-direction: column;
          @include desktop {
            justify-content: center;
          }
        }
        &:nth-of-type(2) {
          grid-area: 1 / 3 / 2 / 4;
        }
        &:nth-of-type(3) {
          grid-area: 1 / 4 / 2 / 5;
        }
        &:nth-of-type(4) {
          /* grid-area: 1 / 3 / 2 / 5; */
          grid-area: 1 / 5 / 2 / 6;
          /* @include desktop {
          } */
        }
        &:nth-of-type(5) {
          /* grid-area: 1 / 5 / 2 / 7; */
          grid-area: 1 / 6 / 2 / 7;
          /* @include desktop {
          } */

        }
        &.centercenter {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.center {
          display: flex;
        }
        &.no-mobile {
          display: none;
          @include desktop {
            display: flex;
          }
        }
        &.only-mobile {
          
          @include desktop {
            display: none;
          }
        }
      }
    }
  }

  .btn-center {
    align-self: center;
  }

  .table {
   

    .cell-progress {
      width: 100%;
      max-width: 40px;
    }

    .table-btn {
      font-weight: 400;
      font-size: 0.8em;      
    }

    .sortable {
      cursor: pointer;
    }
    .btn-sortable {
      text-align: left;
      padding-bottom: 0;
      line-height: 1.3em;
    }
  }
</style>
